<template>
  <div class="promotion-page pk-account-panel">
    <section class="promotion-hero">
      <div class="hero-copy">
        <span class="eyebrow">合作伙伴计划</span>
        <h1>与 PizzaKing<br />一起成长</h1>
        <p>分享你的专属链接或邀请码，邀请玩家加入 PizzaKing。好友完成充值后，合作收益会自动进入你的账户。</p>
        <div class="hero-actions">
          <button @click="copyInvite(valueUrl)">{{ loggedIn ? "复制专属链接" : "登录后参与" }}</button>
          <button class="ghost" @click="goLonger">查看合作明细</button>
        </div>
      </div>
      <div class="hero-visual">
        <div class="coin-orbit orbit-a"></div>
        <div class="coin-orbit orbit-b"></div>
        <img class="visual-logo" src="../assets/hotpizza/pizzaking-logo.svg" alt="pizzaking" />
        <img class="visual-case case-a" src="/img/pizzaking/partner/partner-a.png" alt="" />
        <img class="visual-case case-b" src="/img/pizzaking/partner/partner-b.png" alt="" />
      </div>
    </section>

    <section class="partner-overview">
      <header>
        <div>
          <span>我的合作账户</span>
          <h2>邀请与收益总览</h2>
        </div>
        <button @click="goLonger">查看全部明细</button>
      </header>

      <div class="invite-panel">
        <div class="invite-main">
          <span>专属邀请链接</span>
          <strong>{{ valueUrl || "登录后生成专属邀请链接" }}</strong>
        </div>
        <button @click="copyInvite(valueUrl)">{{ loggedIn ? "复制链接" : "登录后复制" }}</button>
        <button class="muted" @click="copyInvite(valueCode)">{{ loggedIn ? `邀请码 ${valueCode || "-"}` : "查看邀请码" }}</button>
        <button
          class="customize-code"
          :disabled="loggedIn && (!canCustomizeCode || changingInviteCode)"
          @click="customizeInviteCode"
        >
          {{ !loggedIn ? "登录后设置" : (canCustomizeCode ? (changingInviteCode ? "修改中" : "自定义一次") : "邀请码已锁定") }}
        </button>
      </div>

      <div class="stats-grid">
        <article>
          <span>合作用户</span>
          <strong>{{ loggedIn ? peopleNum : "--" }}</strong>
        </article>
        <article>
          <span>当前收益比例</span>
          <strong>{{ loggedIn ? `${ratioText}%` : "--" }}</strong>
        </article>
        <article>
          <span>累计合作收益</span>
          <strong>{{ loggedIn ? moneyText(inviteCommission) : "--" }} <i v-if="loggedIn"></i></strong>
        </article>
        <article>
          <span>收益记录</span>
          <strong>{{ loggedIn ? total : "--" }}</strong>
        </article>
      </div>
    </section>

    <section class="commission-section">
      <div class="commission-head">
        <div>
          <span>收益明细</span>
          <h2>最近合作收益</h2>
        </div>
        <div class="filter-row">
          <button
            v-for="item in dateList"
            :key="item.val"
            :class="{ active: activeDays === item.val }"
            @click="getState(item.val)"
          >
            {{ item.name }}
          </button>
        </div>
      </div>

      <div v-if="tableData.length" class="commission-list">
        <article v-for="item in tableData" :key="item.time + item.name" class="commission-card">
          <div class="user-mark">{{ nameInitial(item.name) }}</div>
          <div class="commission-main">
            <strong>{{ item.name }}</strong>
            <span>{{ item.time }}</span>
          </div>
          <div class="commission-meta">
            <span>充值 {{ moneyText(item.recharge) }}</span>
            <em>比例 {{ item.ratio }}%</em>
          </div>
          <div class="commission-money">{{ moneyText(item.money) }} <i></i></div>
        </article>
      </div>

      <div v-else class="empty-card">暂无合作收益记录。邀请用户完成充值后，记录会自动显示在这里。</div>

      <el-pagination
        v-if="total > pageSize"
        class="page-nav"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="currentChange"
      ></el-pagination>
    </section>

    <section class="material-grid">
      <article v-for="item in materialPacks" :key="item.title" class="material-card">
        <div class="material-glow"></div>
        <img :src="item.img" alt="" />
        <span>{{ item.kicker }}</span>
        <strong>{{ item.title }}</strong>
        <button @click="copyInvite(valueUrl)">获取</button>
      </article>
    </section>

    <section class="steps-section">
      <div class="section-head">
        <span>加入计划</span>
        <h2>分 3 步开始合作</h2>
      </div>
      <div class="steps-grid">
        <article v-for="step in steps" :key="step.title" class="step-card">
          <em>{{ step.num }}</em>
          <strong>{{ step.title }}</strong>
          <p>{{ step.text }}</p>
        </article>
      </div>
    </section>

    <section class="partner-levels">
      <header>
        <div>
          <span>合作等级</span>
          <h2>合作伙伴等级</h2>
        </div>
        <p>等级门槛和展示比例用于说明合作计划；实际收益以你的账户记录为准。</p>
      </header>
      <div class="partner-level-head">
        <span>等级</span><span>距离下一等级</span><span>你的比例</span><span>推荐用户获得</span>
      </div>
      <article v-for="level in partnerLevels" :key="level.level" :class="{ current: level.ratio == Number(ratio || 0) }">
        <b>{{ level.level }}</b>
        <span>{{ level.toNext }}</span>
        <strong>{{ level.ratio }}%</strong>
        <em>{{ level.referral }}</em>
      </article>
    </section>

    <section class="partner-roll-panel">
      <div class="partner-roll-copy">
        <span>专属福利 Roll</span>
        <h2>合作伙伴专属 Roll</h2>
        <p>主播、社群和合作伙伴可申请创建专属 Roll 房，奖品、参与门槛、开奖时间和房间说明会随活动安排同步展示。</p>
        <button @click="applyPartnerRoll">申请创建</button>
      </div>
      <div class="partner-roll-steps">
        <article><b>01</b><strong>提交申请</strong><span>填写合作用途和联系方式</span></article>
        <article><b>02</b><strong>运营配置</strong><span>设置奖品、门槛和开奖规则</span></article>
        <article><b>03</b><strong>公开参与</strong><span>已启用房间展示在 Roll 房列表</span></article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      valueUrl: "",
      valueCode: "",
      canCustomizeCode: false,
      changingInviteCode: false,
      tableData: [],
      peopleNum: 0,
      ratio: 0,
      inviteCommission: 0,
      total: 0,
      page: 1,
      pageSize: 10,
      activeDays: 0,
      dateList: [
        { name: "全部", val: 0 },
        { name: "今天", val: 1 },
        { name: "7 天", val: 7 },
        { name: "30 天", val: 30 },
      ],
      steps: [
        { num: "01", title: "分享链接", text: "将你的专属邀请链接或邀请码发给玩家。" },
        { num: "02", title: "获得收益", text: "合作用户注册并充值后，收益会同步至你的账户记录。" },
        { num: "03", title: "查看账户", text: "在合作明细中查看用户数量、收益比例和结算记录。" },
      ],
      materialPacks: [
        { kicker: "横幅素材", title: "横幅素材包", img: "/img/pizzaking/columns/partner.png" },
        { kicker: "标志素材", title: "标志素材包", img: require("../assets/hotpizza/pizzaking-logo.svg") },
        { kicker: "截图素材", title: "截图素材包", img: require("../assets/hotpizza/hp-gloves.png") },
      ],
      partnerLevels: [
        { level: 1, toNext: "0", ratio: 10, referral: "0.5" },
        { level: 2, toNext: "1 000", ratio: 11, referral: "0.5" },
        { level: 3, toNext: "3 000", ratio: 12, referral: "0.5" },
        { level: 4, toNext: "10 000", ratio: 13, referral: "0.5" },
        { level: 5, toNext: "25 000", ratio: 14, referral: "0.5" },
        { level: 6, toNext: "50 000", ratio: 15, referral: "0.5" },
        { level: 7, toNext: "100 000", ratio: 16, referral: "0.5" },
        { level: 8, toNext: "250 000", ratio: 17, referral: "0.5" },
        { level: 9, toNext: "500 000", ratio: 18, referral: "0.5" },
        { level: 10, toNext: "1 000 000", ratio: 19, referral: "0.5" },
        { level: 11, toNext: "2 000 000", ratio: 20, referral: "0.5" },
      ],
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    ratioText() {
      return Number(this.ratio || 0).toFixed(2).replace(/\.00$/, "");
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.getInviteInfo();
      this.getCommission(0, 1);
    }
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.getInviteInfo();
        this.getCommission(0, 1);
      }
    },
  },
  methods: {
    getInviteInfo() {
      this.$axios.post("index/Invite/inviteInfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.valueCode = res.data.data.invite_code;
          this.valueUrl = `${window.location.origin}/index/invite/reg?code=${res.data.data.invite_code}`;
          this.canCustomizeCode = res.data.data.can_customize_invite_code == 1;
        }
      });
    },
    customizeInviteCode() {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      if (!this.canCustomizeCode) {
        this.$message.warning("邀请码仅可自定义修改一次");
        return;
      }
      this.$prompt("设置后将永久锁定，不能再次修改。仅支持4至16位英文字母或数字。", "自定义邀请码", {
        confirmButtonText: "确认修改",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入新的邀请码",
        inputPattern: /^[A-Za-z0-9]{4,16}$/,
        inputErrorMessage: "请输入4至16位英文字母或数字",
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.changingInviteCode = true;
        return this.$axios
          .post("index/Invite/updateInviteCode", this.$qs.stringify({ invite_code: value }))
          .then((res) => {
            if (res.data.status != 1) {
              this.$message.error(res.data.msg || "邀请码修改失败");
              return;
            }
            this.valueCode = res.data.data.invite_code;
            this.valueUrl = `${window.location.origin}/index/invite/reg?code=${res.data.data.invite_code}`;
            this.canCustomizeCode = false;
            this.$message.success("邀请码修改成功，此后无法再次修改");
          });
      }).catch((error) => {
        if (error !== "cancel" && error !== "close") {
          this.$message.error("邀请码修改失败");
        }
      }).then(() => {
        this.changingInviteCode = false;
      });
    },
    getCommission(days, page) {
      this.activeDays = days;
      this.page = page;
      this.$axios
        .post("index/Invite/offline", this.$qs.stringify({ days, page, pageSize: this.pageSize }))
        .then((res) => {
          if (res.data.status == 1) {
            this.peopleNum = res.data.data.people_num;
            this.ratio = res.data.data.ratio;
            this.inviteCommission = res.data.data.invite_commission;
            this.total = res.data.data.total;
            this.tableData = res.data.data.list;
          }
        });
    },
    getState(val) {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      this.getCommission(val, 1);
    },
    currentChange(val) {
      this.getCommission(this.activeDays, val);
    },
    goLonger() {
      this.$router.push({ path: "/SpreadLonger" });
    },
    applyPartnerRoll() {
      this.$router.push({ path: "/Doubt", query: { category: "cooperation" } });
    },
    copyInvite(text) {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      this.copyText(text);
    },
    openLogin() {
      this.$router.push({ path: "/Login", query: { redirect: this.$route.fullPath } });
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({ message: "复制成功", type: "success" });
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    nameInitial(name) {
      return (name || "P").slice(0, 1).toUpperCase();
    },
  },
};
</script>

<style lang="less" scoped>
.promotion-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f6ff;
  background:
    radial-gradient(circle at 44% 0, rgba(255, 142, 31, 0.2), transparent 30%),
    radial-gradient(circle at 78% 20%, rgba(103, 68, 255, 0.18), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.promotion-hero,
.material-grid,
.steps-section,
.invite-panel,
.stats-grid,
.commission-section {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.promotion-hero {
  min-height: 382px;
  padding: 48px 56px;
  display: grid;
  grid-template-columns: 1fr 520px;
  gap: 34px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(125deg, rgba(39, 41, 55, 0.98), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 135, 28, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.36);
}

.promotion-hero::before {
  content: "";
  width: 920px;
  height: 260px;
  position: absolute;
  right: -180px;
  bottom: -150px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 124, 0, 0.42), transparent 62%);
  opacity: 0.82;
}

.hero-copy,
.hero-visual {
  position: relative;
  z-index: 1;
}

.eyebrow,
.section-head span,
.commission-head span,
.invite-main span,
.material-card span,
.stats-grid span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.hero-copy h1 {
  margin: 12px 0 16px;
  font-size: 66px;
  line-height: 0.98;
  font-weight: 1000;
  letter-spacing: -1.5px;
}

.hero-copy p {
  max-width: 640px;
  color: #aeb6c8;
  font-size: 18px;
  line-height: 1.8;
  font-weight: 800;
}

.hero-actions {
  margin-top: 28px;
  display: flex;
  gap: 12px;
}

.hero-actions button,
.material-card button,
.invite-panel button,
.commission-head button {
  height: 44px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-size: 14px;
  font-weight: 1000;
  box-shadow: 0 12px 30px rgba(255, 121, 0, 0.24);
}

.hero-actions .ghost,
.invite-panel .muted,
.commission-head button {
  color: #f1f4ff;
  background: #292c3a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

.hero-visual {
  height: 280px;
}

.visual-logo {
  width: 280px;
  position: absolute;
  right: 120px;
  top: 22px;
  filter: drop-shadow(0 18px 30px rgba(0, 0, 0, 0.4));
}

.visual-case {
  position: absolute;
  object-fit: contain;
  filter: drop-shadow(0 24px 34px rgba(0, 0, 0, 0.44));
}

.case-a {
  width: 250px;
  right: 214px;
  bottom: 0;
  transform: rotate(-7deg);
}

.case-b {
  width: 214px;
  right: 20px;
  bottom: 12px;
  transform: rotate(8deg);
}

.coin-orbit {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 198, 45, 0.72), rgba(255, 132, 0, 0.2) 46%, transparent 70%);
  filter: blur(1px);
}

.orbit-a {
  width: 260px;
  height: 260px;
  right: 170px;
  top: 30px;
}

.orbit-b {
  width: 180px;
  height: 180px;
  right: 26px;
  bottom: 20px;
}

.material-grid {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.partner-levels {
  max-width: 1280px;
  margin: 24px auto 0;
  overflow: hidden;
  border: 1px solid rgba(104, 112, 141, .28);
  border-radius: 15px;
  background: linear-gradient(180deg, rgba(37, 40, 55, .98), rgba(27, 29, 41, .98));
}
.partner-levels header { min-height: 106px; padding: 24px 28px; display: flex; align-items: center; justify-content: space-between; gap: 24px; background: radial-gradient(ellipse at 10% 10%, rgba(255, 126, 0, .14), transparent 54%); }
.partner-levels header span { color: #ff9b22; font-size: 11px; font-weight: 900; letter-spacing: .17em; }
.partner-levels h2 { margin: 7px 0 0; color: #f6f7fc; font-size: 27px; }
.partner-levels header p { max-width: 450px; margin: 0; color: #9fa8bc; font-size: 13px; line-height: 1.65; }
.partner-level-head, .partner-levels > article { display: grid; grid-template-columns: 110px 1.2fr 1fr 1fr; align-items: center; }
.partner-level-head { min-height: 43px; padding: 0 28px; color: #778198; background: rgba(12, 14, 22, .32); font-size: 11px; font-weight: 900; letter-spacing: .08em; }
.partner-levels > article { min-height: 58px; padding: 0 28px; border-top: 1px solid rgba(255, 255, 255, .055); color: #bac1d2; font-size: 14px; }
.partner-levels > article.current { background: linear-gradient(90deg, rgba(255, 130, 0, .15), transparent 70%); }
.partner-levels > article b { color: #f1f4fb; font-size: 17px; }
.partner-levels > article strong { color: #ffd16c; }
.partner-levels > article em { color: #83dbbd; font-style: normal; }

.partner-roll-panel { max-width: 1280px; margin: 24px auto 0; padding: 30px; display: grid; grid-template-columns: 1.05fr 1.35fr; gap: 28px; align-items: center; border: 1px solid rgba(255, 133, 28, .26); border-radius: 16px; background: radial-gradient(circle at 14% 50%, rgba(255, 124, 0, .16), transparent 38%), #242735; }
.partner-roll-copy > span { color: #ff9f23; font-size: 12px; font-weight: 900; letter-spacing: .16em; }
.partner-roll-copy h2 { margin: 10px 0; color: #fff6e8; font-size: 30px; }
.partner-roll-copy p { margin: 0 0 18px; color: #b9bfcd; line-height: 1.75; font-weight: 700; }
.partner-roll-copy button { height: 42px; padding: 0 20px; color: #241406; border: 0; border-radius: 7px; background: linear-gradient(180deg, #ffd16d, #ff8b1d); font-weight: 900; cursor: pointer; }
.partner-roll-steps { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
.partner-roll-steps article { min-height: 132px; padding: 16px; border: 1px solid #3c4051; border-radius: 10px; background: rgba(30, 33, 45, .76); }
.partner-roll-steps b { display: block; color: #ffae39; font-size: 13px; }
.partner-roll-steps strong { display: block; margin: 14px 0 8px; color: #f8f8ff; }
.partner-roll-steps span { color: #99a1b3; font-size: 12px; line-height: 1.5; }
@media (max-width: 900px) { .partner-roll-panel { grid-template-columns: 1fr; } .partner-roll-steps { grid-template-columns: 1fr; } .partner-levels header { align-items: flex-start; flex-direction: column; } }

.material-card {
  min-height: 230px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(45, 48, 64, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 16px 44px rgba(0, 0, 0, 0.24);
}

.material-glow {
  width: 240px;
  height: 160px;
  position: absolute;
  right: -34px;
  top: 8px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 138, 0, 0.24), transparent 66%);
}

.material-card img {
  width: 178px;
  height: 104px;
  position: relative;
  display: block;
  margin-left: auto;
  object-fit: contain;
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.45));
}

.material-card strong {
  display: block;
  margin: 10px 0 18px;
  color: #f4f7ff;
  font-size: 26px;
  font-weight: 1000;
}

.steps-section,
.commission-section {
  margin-top: 24px;
  padding: 28px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(42, 45, 59, 0.92), rgba(28, 30, 41, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.055);
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.24);
}

.section-head {
  text-align: center;
}

.section-head h2,
.commission-head h2 {
  margin: 8px 0 0;
  color: #f6f8ff;
  font-size: 34px;
  font-weight: 1000;
}

.steps-grid {
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.step-card {
  min-height: 160px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.step-card em {
  position: absolute;
  right: 18px;
  top: 12px;
  color: rgba(255, 138, 0, 0.18);
  font-size: 58px;
  font-style: normal;
  font-weight: 1000;
}

.step-card strong {
  position: relative;
  display: block;
  color: #fff4d8;
  font-size: 22px;
  font-weight: 1000;
}

.step-card p {
  position: relative;
  margin: 14px 0 0;
  color: #9fa8bb;
  font-size: 14px;
  line-height: 1.8;
  font-weight: 800;
}

.invite-panel {
  margin-top: 24px;
  padding: 18px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto auto;
  gap: 12px;
  align-items: center;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.invite-panel button:disabled {
  color: #7f8799;
  background: #303341;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: none;
  cursor: not-allowed;
}

.invite-main strong {
  display: block;
  margin-top: 7px;
  color: #f6f8ff;
  font-size: 15px;
  font-weight: 900;
  word-break: break-all;
}

.stats-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.stats-grid article {
  min-height: 104px;
  padding: 20px;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.stats-grid strong {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #f8fbff;
  font-size: 28px;
  font-weight: 1000;
}

.stats-grid i,
.commission-money i {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.commission-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.filter-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.commission-head button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
}

.commission-list {
  margin-top: 20px;
  display: grid;
  gap: 10px;
}

.commission-card,
.empty-card {
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
}

.commission-card {
  min-height: 86px;
  padding: 14px 16px;
  display: grid;
  grid-template-columns: 54px 1fr 180px 120px;
  gap: 16px;
  align-items: center;
}

.user-mark {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border-radius: 50%;
  font-weight: 1000;
}

.commission-main strong {
  display: block;
  color: #f4f7ff;
  font-size: 16px;
  font-weight: 1000;
}

.commission-main span,
.commission-meta span,
.commission-meta em {
  display: block;
  margin-top: 6px;
  color: #9aa3b8;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.commission-money {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  color: #ffd764;
  font-size: 21px;
  font-weight: 1000;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
}

.page-nav {
  margin-top: 16px;
  text-align: right;
}

.page-nav /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.page-nav /deep/ .el-pagination.is-background .btn-next,
.page-nav /deep/ .el-pagination.is-background .btn-prev,
.page-nav /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

@media screen and (max-width: 1080px) {
  .promotion-page {
    padding: 20px 12px 64px;
  }

  .promotion-hero,
  .material-grid,
  .steps-grid,
  .invite-panel,
  .stats-grid,
  .commission-card {
    grid-template-columns: 1fr;
  }

  .promotion-hero {
    padding: 34px 24px;
  }

  .hero-copy h1 {
    font-size: 46px;
  }

  .hero-visual {
    height: 240px;
  }

  .visual-logo {
    left: 0;
    right: auto;
  }

  .case-a {
    left: 10px;
    right: auto;
  }

  .case-b {
    right: 10px;
  }

  .commission-money {
    justify-content: flex-start;
  }
}

/* 2026-07-05 exact internal pass: promotion page. */
.promotion-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.promotion-page.pk-account-panel .promotion-hero,
.promotion-page.pk-account-panel .material-grid,
.promotion-page.pk-account-panel .steps-grid,
.promotion-page.pk-account-panel .invite-panel,
.promotion-page.pk-account-panel .stats-grid,
.promotion-page.pk-account-panel .commission-card,
.promotion-page.pk-account-panel .invite-records {
  width: 100% !important;
  max-width: none !important;
}

.promotion-page.pk-account-panel .promotion-hero {
  min-height: 286px !important;
  padding: 30px 38px !important;
  box-sizing: border-box;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 75% 52%, rgba(255, 138, 31, 0.16), transparent 48%),
    #20222f !important;
  box-shadow: none !important;
}

.promotion-page.pk-account-panel .hero-copy h1 {
  color: #f4ead8 !important;
  font-size: 52px !important;
}

.promotion-page.pk-account-panel .material-card,
.promotion-page.pk-account-panel .step-card,
.promotion-page.pk-account-panel .invite-panel,
.promotion-page.pk-account-panel .stats-grid article,
.promotion-page.pk-account-panel .commission-card,
.promotion-page.pk-account-panel .invite-records {
  border-color: #2b2d3c !important;
  background: #20222f !important;
  border-radius: 8px !important;
}

.promotion-page.pk-account-panel .partner-overview {
  width: 100%;
  max-width: none;
  margin: 22px auto 0;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background:
    radial-gradient(circle at 88% 0, rgba(255, 139, 31, 0.11), transparent 260px),
    #20222f;
}

.promotion-page.pk-account-panel .partner-overview > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.promotion-page.pk-account-panel .partner-overview > header span {
  color: #ff9b22;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.promotion-page.pk-account-panel .partner-overview > header h2 {
  margin: 7px 0 0;
  color: #f7f3e9;
  font-size: 28px;
}

.promotion-page.pk-account-panel .partner-overview > header button {
  height: 40px;
  padding: 0 18px;
  color: #f5ead5;
  border: 1px solid rgba(255, 174, 49, 0.38);
  border-radius: 6px;
  background: #292c3a;
  font-weight: 900;
}

.promotion-page.pk-account-panel .partner-overview .invite-panel {
  max-width: none;
  margin-top: 20px;
  background: #262936 !important;
}

.promotion-page.pk-account-panel .partner-overview .stats-grid {
  max-width: none;
}

@media screen and (max-width: 1080px) {
  .promotion-page.pk-account-panel .partner-overview {
    padding: 18px;
  }

  .promotion-page.pk-account-panel .partner-overview > header {
    align-items: flex-start;
  }
}

@media screen and (max-width: 600px) {
  .promotion-page.pk-account-panel .partner-overview {
    margin-top: 12px;
    padding: 14px;
  }

  .promotion-page.pk-account-panel .partner-overview > header {
    display: block;
  }

  .promotion-page.pk-account-panel .partner-overview > header h2 {
    font-size: 22px;
  }

  .promotion-page.pk-account-panel .partner-overview > header button {
    width: 100%;
    margin-top: 14px;
  }

  .promotion-page.pk-account-panel .partner-overview .invite-panel,
  .promotion-page.pk-account-panel .partner-overview .stats-grid {
    grid-template-columns: 1fr;
  }

  .promotion-page.pk-account-panel .promotion-hero {
    min-height: 0 !important;
  }

  .promotion-page.pk-account-panel .hero-copy h1 {
    font-size: 38px !important;
  }
}
</style>
